<template>
  <div class="pb-1">
    <b-card no-body>
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h2>สารบัญ</h2>
      </b-card-header>
      <b-card-body class="mt-1">
        <ul class="list-group">
          <strong>วิธีการสั่งใน taobao</strong>
          <a href="#card-1" class="list-group-item-action">○ 1.ติดตั้งโปรแกรมแชทกับร้านค้า</a>
          <a href="#card-2" class="list-group-item-action">○ 2.ล๊อกอินเข้า Taobao</a>
          <a href="#card-3" class="list-group-item-action">○ 3.การเช็คค่าส่งในจีน และ กดสั่งสินค้า</a>
          <a href="#card-4" class="list-group-item-action">○ 4.การเข้าไปดูสถานะสินค้า</a>
          <a href="#card-5" class="list-group-item-action">○ 5.การต่อรองราคาค่าส่งในจีน</a>
          <a href="#card-6" class="list-group-item-action">○ 6.การกดยกเลิกสินค้า</a>
          <a href="#card-7" class="list-group-item-action">○ 7.วิธีการชำระเงิน</a>
          <a href="#card-8" class="list-group-item-action">○ 8.การนำเลขแทรคสินค้าไปแจ้งในระบบ Taobao2you</a>
          <a href="#card-9" class="list-group-item-action">○ 9.การกดขอคืนเงินจากร้านค้า</a>
          <a href="#card-10" class="list-group-item-action">○ 10.การหารายการที่สั่งไปแล้วใน taobao</a>
        </ul>
        <div class="list-group mt-1">
          <strong>วิธีการสั่งใน 1688.com</strong>
          <a href="#card-11" class="list-group-item-action">○ 11.การสั่งของจาก 1688.com ค่ะ</a>
          <a href="#card-12" class="list-group-item-action">○ 12.เช็คค่าส่งในจีนและกดสั่งสินค้าใน 1688.com</a>
          <a href="#card-13" class="list-group-item-action">○ 13.การดูสถานะออเดอร์ใน 1688.com</a>
          <a href="#card-14" class="list-group-item-action">○ 14.กดยกเลิกสินค้าใน 1688.com</a>
          <a href="#card-15" class="list-group-item-action">○ 15.การจ่ายเงินใน 1688.com</a>
          <a href="#card-16" class="list-group-item-action">○ 16.เอาเลขแทรคมาแจ้งเพื่อเชคสถานะ</a>
          <a href="#card-17" class="list-group-item-action">○ 17.การกดคืนเงินในเวป 1688.com</a>
          <a href="#card-18" class="list-group-item-action">○ 18.การหารายการที่สั่งไปแล้วใน 1688</a>
        </div>
        <div class="list-group mt-1">
          <strong>เคล็ดลับ แต่ไม่ลับ</strong>
          <a href="#card-10" class="list-group-item-action">○ การหารายการที่สั่งไปแล้วใน taobao</a>
          <a href="#card-18" class="list-group-item-action">○ การหารายการที่สั่งไปแล้วใน 1688</a>
          <a href="#card-19" class="list-group-item-action">○ คำศัพท์พื้นฐานใช้คุยกับร้านจีน</a>
        </div>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-1">
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h2>1.ติดตั้งโปรแกรมแชทกับร้านค้า</h2>
      </b-card-header>
      <b-card-body>
        <div class="py-1">ก่อนที่เราจะทำการสั่งของกับร้านค้าจีน เราต้องมีโปรแกรมเอาไว้ติดต่อพูดคุยกับร้านค้าจีนก่อนค่ะ</div>
        <div class="pb-1">- สำหรับใน taobao, tmall, 1688.com, alibaba.com ใช้โปรแกรม trademanager</div>
        <div class="pb-1">
          ดาวน์โหลดโปรแกรม
          <b-link href="https://activity.alibaba.com/page/alibabasupplier.html" target="_blank">>>คลิก<<</b-link>
        </div>
        <div class="pb-1">
          - สำหรับร้านค้าจีนนอกเวปที่กล่าวมาเราจะใช้ QQ ค่ะ
          <b-link href="https://www.imqq.com/" target="_blank">>>คลิก<<</b-link>
          เพื่อดาวน์โหลดโปรแกรม
        </div>
        <div class="pb-1">เมื่อโหลดโปรแกรม trademanager และ ติดตั้งเสร็จแล้ว ให้เปิดโปรแกรมขึ้นมา</div>
        <b-img :src="require('@/assets/how-to-img/1-1.jpg')" thumbnail></b-img>
        <div class="py-1">จากนั้นเริ่มล๊อกอินเลยค่ะ</div>
        <b-img :src="require('@/assets/how-to-img/1-2.jpg')" thumbnail></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-2">
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h2>2.ล๊อกอินเข้า Taobao</h2>
      </b-card-header>
      <b-card-body>
        <div class="py-1">ก่อนที่จะสั่งของเราต้องล๊อกอินก่อนค่ะ</div>
        <div class="pb-1">
          ไปที่
          <b-link href="https://world.taobao.com/" target="_blank"> www.taobao.com</b-link>
        </div>
        <b-img :src="require('@/assets/how-to-img/2-1.jpg')" thumbnail></b-img>
        <div class="py-1">จากนั้นใส่ username และ password</div>
        <b-img :src="require('@/assets/how-to-img/2-2.jpg')" thumbnail></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-3">
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h2>3.การเช็คค่าส่งในจีน และ กดสั่งสินค้า</h2>
      </b-card-header>
      <b-card-body>
        <div class="py-1">ยกตัวอย่างสินค้าตามด้านล่างนี้นะคะ</div>
        <b-img :src="require('@/assets/how-to-img/3-1.jpg')" thumbnail ></b-img>
        <b-img :src="require('@/assets/how-to-img/Arrow.jpg')" thumbnail ></b-img>
        <b-img :src="require('@/assets/how-to-img/3-2.jpg')" thumbnail ></b-img>
        <div class="py-1">เราสามารถกดเข้าตะกร้าได้เรื่อยๆค่ะ<br>
        กดเข้าได้สูงสุดที่ 50 ชิ้น<br>
        ต่อไปเราจะเข้าไปดูในตะกร้ากันนะคะ</div>
        <b-img :src="require('@/assets/how-to-img/3-3.jpg')" thumbnail ></b-img>
        <b-img :src="require('@/assets/how-to-img/Arrow.jpg')" thumbnail ></b-img>
        <div class="py-1">จะเห็นได้ว่า ระบบมันจะแยกร้านค้าให้เรียบร้อยเลย</div>
        <b-img :src="require('@/assets/how-to-img/3-4.jpg')" thumbnail ></b-img>
        <b-img :src="require('@/assets/how-to-img/Arrow.jpg')" thumbnail ></b-img>
        <b-img :src="require('@/assets/how-to-img/3-5.jpg')" thumbnail ></b-img>
        <div class="py-1">พอมาถึงตรงนี้ เราจะสามารถเชคค่าส่งในจีนได้<br>
        เราสามารถกดเข้ามาเพื่อเชคค่าส่งเฉยๆก่อนก็ได้ ไม่จำเป็นต้องกดสั่งซื้อทุกครั้ง<br>
        ถ้ายังไม่ต้องการสั่งซื้อก็แค่ลบรายการที่ไม่เอาออกค่ะ<br>
        แต่ถ้าจะสั่งซื้อเลยก็ให้กดปุ่มสีส้มตามรูปค่ะ</div>
        <b-img :src="require('@/assets/how-to-img/3-6.jpg')" thumbnail ></b-img><br>
        <b-img :src="require('@/assets/how-to-img/Arrow.jpg')" thumbnail ></b-img><br>
        <b-img :src="require('@/assets/how-to-img/3-7.jpg')" thumbnail ></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-4">
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h2>4.การเข้าไปดูสถานะสินค้า</h2>
      </b-card-header>
      <b-card-body>
        <div class="py-1">ทีนี้เราจะไปดูได้อย่างไรว่าของที่เรากดเข้าไปจะไปอยู่ตรงไหน<br>
        ให้ลูกค้ากดตรงชื่อ ID ของเราตรงมุมซ้ายบนเพื่อเข้ามาหน้านี้ค่ะ<br>
        หน้านี้จะรวมทุกสิ่งอย่างของเรา</div>
        <b-img :src="require('@/assets/how-to-img/4-1.jpg')" thumbnail></b-img>
        <div class="py-1">เมื่อเรากดเข้ามาก็จะเจอหน้าแบบนี้</div>
        <b-img :src="require('@/assets/how-to-img/4-2.jpg')" thumbnail></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-5">
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h2>5.การต่อรองราคาค่าส่งในจีน</h2>
      </b-card-header>
      <b-card-body>
        <div class="pt-1">ถ้าหากว่าค่าส่งในจีนร้านไหนแพงไปเราสามารถต่อรองกับร้านค้าได้ค่ะ</div>
        <strong>ควรต่อราคาก่อนชำระเงิน เพราะถ้าต่อราคาหลังจากชำระเงินไปแล้ว ส่วนใหญ่ไม่ค่อยจะคืนค่ะ</strong>
        <div>โดยการกดที่ตัวสีฟ้า เพื่อเปิดโปรแกรมแชทคุยกับร้านค้าที่จะต่อรองราคาค่ะ<br>
        แล้วพิมพ์ตามนี้นะคะ</div>
        <div class="py-1">你好<br>订单 : (ใส่เลขที่ใบสั่งซื้อ)<br>快递费可以少一点吗？</div>
        <div class="pb-1">หลังจากนั้นก็รอร้านค้าแก้ค่าส่งในจีน<br>
        หรือบางครั้งร้านค้าอาจไม่แก้ค่าส่งเลยก็มีค่ะ เค้าอาจจะบอกว่าค่าส่งถูกต้องแล้ว</div>
        <b-img :src="require('@/assets/how-to-img/5-1.jpg')" thumbnail></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-6">
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h2>6.การกดยกเลิกสินค้า</h2>
      </b-card-header>
      <b-card-body>
        <div class="py-1">ในกรณีที่เรากดผิดหรือไม่ต้องการสินค้า สามารถกดยกเลิกได้ค่ะ<br>
        จะกดยกเลิกได้ก็ต่อเมื่อสถานะของออเดอร์เป็น รอชำระเงิน เท่านั้นนะคะ<br>
        ถ้าจ่ายเงินแล้วไม่สามารถยกเลิกได้ค่ะ</div>
        <b-img :src="require('@/assets/how-to-img/6-1.jpg')" thumbnail></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-7">
      <b-card-header class="mb-1" header-bg-variant="light" header-border-variant="secondary">
        <h2>7. วิธีการชำระเงิน</h2>
      </b-card-header>
      <b-card-body>
        <b-img :src="require('@/assets/how-to-img/7-1.jpg')" thumbnail></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-8">
      <b-card-header class="mb-1" header-bg-variant="light" header-border-variant="secondary">
        <h2>8.การนำเลขแทรคสินค้าไปแจ้งในระบบ Taobao2you</h2>
      </b-card-header>
      <b-card-body>
        <div class="pt-1">เมื่อร้านค้าส่งของออกมาแล้ว เราก็อยากรู้ว่าจะถึงโกดังวันไหน จะถึงไทยเมื่อไหร่ ให้ทำตามนี้ค่ะ</div>
        <b-img :src="require('@/assets/how-to-img/8-1.jpg')" thumbnail></b-img>
        <div class="pt-1">จากนั้นเราก็จะมาเจอหน้านี้ค่ะ</div>
        <b-img :src="require('@/assets/how-to-img/8-2.jpg')" thumbnail></b-img>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-img/8-3.jpg')" thumbnail></b-img></div>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-9">
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h2>9.การกดขอคืนเงินจากร้านค้า</h2>
      </b-card-header>
      <b-card-body>
        <div class="py-1">กรณีของหมดมี 3 กรณี<br>
        1.จ่ายตังร้านค้าแล้วแต่ร้านบอกของหมด<br>
        2.ร้านค้าส่งของมาแล้ว แต่ไม่ได้รับของ<br>
        3.ของอยู่ในสถานะการซื้อขายสำเร็จแล้ว แต่ไม่ได้รับของ</div>
        <h4 class="pb-1">- กรณีแรก จ่ายตังร้านค้าแล้วแต่ร้านบอกของหมด (สถานะออเดอร์คือจ่ายเงินแล้วแต่ยังไม่ส่งของ)</h4>
        <div>กรณีแบบนี้ส่วนใหญ่ร้านค้าเค้าจะมาบอกในแชทว่าของหมดแล้ว ไม่มีของส่ง ให้กดคืนเงินเลย<br>
        ให้ไปที่สถานะ <strong>"จ่ายแล้วแต่ร้านค้ายังไม่ส่งออก"</strong></div>
        <b-img :src="require('@/assets/how-to-img/9-1.jpg')" thumbnail></b-img>
        <div class="pt-1">เลือกเหตุผล</div>
        <b-img :src="require('@/assets/how-to-img/9-2.jpg')" thumbnail></b-img>
        <div class="py-1"><b-img :src="require('@/assets/how-to-img/9-3.jpg')" thumbnail></b-img></div>
        <div>ตรงนี้มันจะบอกเราว่าเมื่อไหร่ถึงจะได้เงินคืน</div>
        <b-img :src="require('@/assets/how-to-img/9-4.jpg')" thumbnail></b-img>
        <div class="pt-1">ถ้าเราเข้าไปดูอีกรอบ มันจะบอกสถานะว่าคืนเงินหรือยัง</div>
        <b-img :src="require('@/assets/how-to-img/9-5.jpg')" thumbnail></b-img>

        <h4 class="pt-3 pb-1">-กรณีที่สอง ร้านค้าส่งของออกมาแล้ว จะแยกเป็นอีกสองกรณีค่ะ คือ</h4>
        <div>+ ไม่ได้รับของเลย<br>+ ได้รับของแต่ไม่ครบตามจำนวนชิ้นที่สั่ง</div>
        <b-img :src="require('@/assets/how-to-img/9-6.jpg')" thumbnail></b-img>
        <div class="py-1"><b-img :src="require('@/assets/how-to-img/9-7.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-8.jpg')" thumbnail></b-img></div>
        <b-img :src="require('@/assets/how-to-img/9-9-23.jpg')" thumbnail></b-img>
        <div class="pt-1">ถ้าเลือกเหตุผลว่า "อื่นๆ" โดยทั่วไปจะใส่หมายเหตุว่า<br>
        "缺货" ซึ่งแปลว่าของขาด หรือไม่มีของส่งมา หรือ<br>
        "没有收到货" ซึ่งแปลว่าไม่ไดรับของ<br>
        หรืออาจจะใส่คำอื่นก็ได้ค่ะ ถ้าสามารถใช้ภาษาจีนได้</div>
        <b-img :src="require('@/assets/how-to-img/9-10-25.jpg')" thumbnail></b-img>
        <div class="pt-1">+ แต่ถ้าเป็นกรณีที่เราได้รับของ แต่ไม่ครบ</div>
        <b-img :src="require('@/assets/how-to-img/9-11-24.jpg')" thumbnail></b-img>
        <div class="pt-1">บางทีก็อาจจะเจอช่องเลือกเหตุผลแบบด้านล่าง</div>
        <b-img :src="require('@/assets/how-to-img/9-12.jpg')" thumbnail></b-img>
        <div class="pt-1">ปกติชอบเลือกเหตุผลว่าอื่นๆแล้วก็ไปใส่หมายเหตุเอาค่ะ<br>
        没有收到 1 个 = ไม่ได้รับของ 1 ชิ้น</div>
        <b-img :src="require('@/assets/how-to-img/9-13.jpg')" thumbnail></b-img>
        <div class="py-1"><b-img :src="require('@/assets/how-to-img/9-14.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-15.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-16.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-17.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-18.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-19.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-20.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-21.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-22.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-9-23.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-11-24.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-10-25.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/9-23.jpg')" thumbnail></b-img></div>
        <b-img :src="require('@/assets/how-to-img/9-24.jpg')" thumbnail></b-img>
        <div class="pt-1">**ถ้าหากร้านจีนปฏิเสธการคืนเงิน แล้วเราไม่ได้ตามมาดูจนปล่อยเวลาให้วิ่งหมด<br>
        เราก็จะไม่ได้เงินคืน มีทางเดียวต้องแชทคุยกับร้านค้าเท่านั้นค่ะ</div>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-10">
      <b-card-header class="mb-1" header-bg-variant="light" header-border-variant="secondary">
        <h2>10.การหารายการที่สั่งไปแล้วใน taobao</h2>
      </b-card-header>
      <b-card-body>
        <div class="pt-1">ขั้นแรกเปิดลิ้งค์สินค้าที่สั่งไปก่อนค่ะ<br>
        เราจะทำการหารายการที่สั่งไปโดยใช้ชื่อร้าน</div>
        <b-img :src="require('@/assets/how-to-img/10-1.jpg')" thumbnail></b-img>
        <div class="py-1"><b-img :src="require('@/assets/how-to-img/10-2.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-img/10-3.jpg')" thumbnail></b-img></div>
        <b-img :src="require('@/assets/how-to-img/10-4.jpg')" thumbnail></b-img>
        <div class="py-1">หรือเราสามารถหาจากชื่อสินค้าก็สามารถทำได้ค่ะ</div>
        <b-img :src="require('@/assets/how-to-img/10-5.jpg')" thumbnail></b-img>
        <div class="py-1"><b-img :src="require('@/assets/how-to-img/10-6.jpg')" thumbnail></b-img></div>
        <b-img :src="require('@/assets/how-to-img/10-7.jpg')" thumbnail></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-11">
      <b-card-header class="mb-1" header-bg-variant="light" header-border-variant="secondary">
        <h2>11.ต่อไปจะเป็นการสั่งของจาก 1688.com ค่ะ</h2>
      </b-card-header>
      <b-card-body>
        <b-img :src="require('@/assets/how-to-1688/11-1.jpg')" thumbnail></b-img>
        <div class="pt-1">ทีนี้เรามาดูหน้าแรกก่อนว่าแต่ละส่วนคืออะไร</div>
        <b-img :src="require('@/assets/how-to-1688/11-2.jpg')" thumbnail></b-img>
        <div class="pt-1">ในลิ้งค์สินค้าที่เราจะสั่ง มาดูกันค่ะว่าแต่ละส่วนหมายความว่ายังไง</div>
        <b-img :src="require('@/assets/how-to-1688/11-3.jpg')" thumbnail></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-12">
      <b-card-header class="mb-1" header-bg-variant="light" header-border-variant="secondary">
        <h2>12.เช็คค่าส่งในจีนและกดสั่งสินค้าใน 1688.com</h2>
      </b-card-header>
      <b-card-body>
        <b-img :src="require('@/assets/how-to-1688/12-1.jpg')" thumbnail></b-img>
        <div class="py-1"><b-img :src="require('@/assets/how-to-1688/12-2.jpg')" thumbnail></b-img></div>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-1688/12-3.jpg')" thumbnail></b-img></div>
        <b-img :src="require('@/assets/how-to-1688/12-4.jpg')" thumbnail></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-13">
      <b-card-header class="mb-1" header-bg-variant="light" header-border-variant="secondary">
        <h2>13.การดูสถานะออเดอร์ใน 1688.com</h2>
      </b-card-header>
      <b-card-body>
        <b-img :src="require('@/assets/how-to-1688/13-1.jpg')" thumbnail></b-img>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/13-2.jpg')" thumbnail></b-img></div>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-14">
      <b-card-header class="mb-1" header-bg-variant="light" header-border-variant="secondary">
        <h2>14.กดยกเลิกสินค้าใน 1688.com</h2>
      </b-card-header>
      <b-card-body>
        <b-img :src="require('@/assets/how-to-1688/14-1.jpg')" thumbnail></b-img>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/14-2.jpg')" thumbnail></b-img></div>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-15">
      <b-card-header class="mb-1" header-bg-variant="light" header-border-variant="secondary">
        <h2>15.การจ่ายเงินใน 1688.com</h2>
      </b-card-header>
      <b-card-body>
        <div class="pt-1">ถ้าหากเห็นว่าค่าส่งในจีนแพงไป หรืออยากต่อรองลดราคาสินค้าก็ทำได้นะคะ</div>
        <b-img :src="require('@/assets/how-to-1688/15-1.jpg')" thumbnail></b-img>
        <div class="pt-1">ถ้าพอใจกับราคาแล้วก็จ่ายเงินได้เลยค่ะ</div>
        <b-img :src="require('@/assets/how-to-1688/15-2.jpg')" thumbnail></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-16">
      <b-card-header class="mb-1" header-bg-variant="light" header-border-variant="secondary">
        <h2>16.เอาเลขแทรคมาแจ้งเพื่อเชคสถานะ</h2>
      </b-card-header>
      <b-card-body>
        <b-img :src="require('@/assets/how-to-1688/16-1.jpg')" thumbnail></b-img>
        <div class="py-1"><b-img :src="require('@/assets/how-to-1688/16-2.jpg')" thumbnail></b-img></div>
        <b-img :src="require('@/assets/how-to-1688/16-3.jpg')" thumbnail></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-17">
      <b-card-header class="mb-1" header-bg-variant="light" header-border-variant="secondary">
        <h2>17.การกดคืนเงินในเวป 1688.com</h2>
      </b-card-header>
      <b-card-body>
        <div class="py-1">กรณีของหมดมี 3 กรณี<br>
        1.จ่ายตังร้านค้าแล้วแต่ร้านบอกของหมด<br>
        2.ร้านค้าส่งของมาแล้ว แต่ไม่ได้รับของ<br>
        3.ของอยู่ในสถานะการซื้อขายสำเร็จแล้ว แต่ไม่ได้รับของ</div>
        <h4>- กรณีแรก จ่ายตังร้านค้าแล้วแต่ร้านบอกของหมด (สถานะออเดอร์คือจ่ายเงินแล้วแต่ยังไม่ส่งของ)</h4>
        <div class="pt-1">กรณีแบบนี้ส่วนใหญ่ร้านค้าเค้าจะมาบอกในแชทว่าของหมดแล้ว ไม่มีของส่ง ให้กดคืนเงินเลย<br>
        ให้ไปที่สถานะ<strong> "จ่ายแล้วแต่ร้านค้ายังไม่ส่งออก"</strong></div>
        <b-img :src="require('@/assets/how-to-1688/17-1.jpg')" thumbnail></b-img>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-2.jpg')" thumbnail></b-img></div>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-3.jpg')" thumbnail></b-img></div>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-4.jpg')" thumbnail></b-img></div>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-5-14.jpg')" thumbnail></b-img></div>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-6-15.jpg')" thumbnail></b-img></div>
        <div class="py-1"><b-img :src="require('@/assets/how-to-1688/17-7.jpg')" thumbnail></b-img></div>
        <b-img :src="require('@/assets/how-to-1688/17-8.jpg')" thumbnail></b-img>
        <h4 class="py-1">-กรณีที่สอง ร้านค้าส่งของออกมาแล้ว จะแยกเป็นอีกสองกรณีค่ะ คือ</h4>
        <div>+ ไม่ได้รับของเลย<br>
        + ได้รับของแต่ไม่ครบตามจำนวนชิ้นที่สั่ง</div>
        <b-img :src="require('@/assets/how-to-1688/17-9.jpg')" thumbnail></b-img>
        <div class="py-1"><b-img :src="require('@/assets/how-to-1688/17-10.jpg')" thumbnail></b-img></div>
        <b-img :src="require('@/assets/how-to-1688/17-11.jpg')" thumbnail></b-img>
        <div class="pt-1">การใส่หมายเหตุ<br>
        -ถ้าไม่ได้รับเลยใส่ 没有收到货<br>
        -ได้รับไม่ครบ เช่นสั่ง 5 ได้มา 3 ขาด 2 ก็ใส่ 订 5 件 只收到3 件 缺货2件</div>
        <b-img :src="require('@/assets/how-to-1688/17-12.jpg')" thumbnail></b-img>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-13.jpg')" thumbnail></b-img></div>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-5-14.jpg')" thumbnail></b-img></div>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-6-15.jpg')" thumbnail></b-img></div>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-14-22.jpg')" thumbnail></b-img></div>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-15-23.jpg')" thumbnail></b-img></div>
        <div class="py-1"><b-img :src="require('@/assets/how-to-1688/17-16-24.jpg')" thumbnail></b-img></div>
        <b-img :src="require('@/assets/how-to-1688/17-17.jpg')" thumbnail></b-img>
        <h4 class="pt-1">-กรณีที่สาม ของอยู่ในสถานะการซื้อขายสำเร็จแล้ว แต่ไม่ได้รับของ</h4>
        <div class="pb-1"><b-img :src="require('@/assets/how-to-1688/17-18.jpg')" thumbnail></b-img></div>
        <b-img :src="require('@/assets/how-to-1688/17-19.jpg')" thumbnail></b-img>
        <div>การใส่หมายเหตุ<br>
        -ถ้าไม่ได้รับเลยใส่ 没有收到货<br>
        -ได้รับไม่ครบ เช่นสั่ง 5 ได้มา 3 ขาด 2 ก็ใส่ 订 5 件 只收到3 件 缺货2件</div>
        <b-img :src="require('@/assets/how-to-1688/17-20.jpg')" thumbnail></b-img>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-21.jpg')" thumbnail></b-img></div>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-14-22.jpg')" thumbnail></b-img></div>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/17-15-23.jpg')" thumbnail></b-img></div>
        <div class="py-1"><b-img :src="require('@/assets/how-to-1688/17-16-24.jpg')" thumbnail></b-img></div>
        <b-img :src="require('@/assets/how-to-1688/17-22.jpg')" thumbnail></b-img>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-18">
      <b-card-header class="mb-1" header-bg-variant="light" header-border-variant="secondary">
        <h2>18.การหารายการที่สั่งไปแล้วใน 1688</h2>
      </b-card-header>
      <b-card-body>
        <b-img :src="require('@/assets/how-to-1688/18-1.jpg')" thumbnail></b-img>
        <div class="pt-1"><b-img :src="require('@/assets/how-to-1688/18-2.jpg')" thumbnail></b-img></div>
      </b-card-body>
    </b-card>

    <b-card no-body id="card-19">
      <b-card-header class="mb-1" header-bg-variant="light" header-border-variant="secondary">
        <h2>19.คำศัพท์พื้นฐานใช้คุยกับร้านจีน</h2>
      </b-card-header>
      <b-card-body>
        <div>你 = คุณ<br>
        我 = ฉัน<br>
        亲 = คุณ (จะเพราะกว่าอันแรก)<br>
        好 = ดี<br>
        要 = เอา<br>
        不要 = ไม่เอา<br>
        是 = ใช่<br>
        不是 = ไม่ใช่<br>
        对 = ถูก<br>
        不对 = ไม่ถูก<br>
        地址 = ที่อยู่<br>
        货 = สินค้า<br>
        商品 = สินค้า<br>
        什么时候 = เมื่อไหร่<br>
        发货 = ส่งของ<br>
        现货 = ของพร้อมส่ง<br>
        定金 = มัดจำ<br>
        定做 = สั่งทำ<br>
        颜色 = สี<br>
        什么 = อะไร<br>
        为什么 = ทำไม<br>
        如果 = ถ้า<br>
        因为 = เพราะ<br>
        这个 = อันนี้<br>
        那个 = อันนั้น<br>
        哪个 = อันไหน<br>
        吗 = หรือเปล่า(ใช้ลงท้ายประโยคคำถาม)<br>
        了 = แล้ว (ใช้ลงท้ายประโยคบอกเล่า)<br>
        的 = แล้ว (ใช้ลงท้ายประโยคบอกเล่า)<br>
        看 = มอง<br>
        查 = หา<br>
        知道 = เข้าใจ<br>
        缺货 = ของขาด<br>
        收到 = ได้รับ<br>
        忙 = ยุ่ง<br>
        多 = มาก<br>
        少 = น้อย<br>
        钱 = เงิน<br>
        多少钱 = ราคาเท่าไหร่<br>
        一点 = นิดหน่อย<br>
        价格 = ราคา<br>
        订 = สั่ง<br>
        快递费 = ค่าไปรษณีย์</div>
        <div class="pt-2">ประโยคใช้บ่อย<br>
        我现在很忙。= ตอนนี้ฉันยุ่งมาก<br>
        什么时候可以发货？ = เมื่อไหร่จะส่งของ<br>
        我查看一下 = ฉันเช็คแปปหนึ่ง<br>
        这个有货吗？ = อันนี้มีของมั้ย<br>
        这个有现货吗？ = อันนี้มีของพร้อมส่งมั้ย<br>
        我知道了 = ฉันรู้แล้ว<br>
        我明白了。= ฉันเข้าใจแล้ว<br>
        好的 = OK<br>
        没有收到 = ไม่ได้รับ<br>
        没有收到货 = ไม่ได้รับของ<br>
        不要了 = ไม่เอาแล้ว<br>
        看到了 = มองเห็นแล้ว<br>
        很忙 = ยุ่งมาก<br>
        我在看 = กำลังหา<br>
        我查看一下 = ฉันเช็คแปปหนึ่ง<br>
        我买了很多，便宜一点给我可以吗？ = สั่งเยอะ ลดราคาสินค้าให้หน่อยได้หรือเปล่า<br>
        运费可以少一点给我吗？ = ลดราคาค่าไปรษณีย์จีนให้หน่อยได้หรือเปล่า<br>
        我已经申请退款了，因为这个发错了，我地址在广州白云，麻烦你处理一下 = ฉันกดขอคืนเงินแล้ว เพราะรายการนี้คุณส่งผิด ที่อยู่ของฉันอยู่ที่กวางโจว รบกวนจัดการให้ทีค่ะ<br>
        这个我买了4个但是只收到2个，另外是你没有货或者分开发呢，如果分开发麻烦你把运单号给我一下 = รายการนี้ฉันซื้อ 4 ชิ้น แต่ได้รับแค่ 2ชิ้น ที่เหลือ คือคุณไม่มีของหรือว่าแบ่งส่งคะ ถ้าแบ่งส่งรบกวนขอเลขแทร็คอีกอันหน่อยค่ะ (เปลี่ยนจำนวนตามที่ไม่ได้รับแค่นั้นค่ะ)<br>
        你会说英语吗？= คุณพูดภาษาอังกฤษได้ไหม<br>
        我不懂 = ฉันไม่เข้าใจ<br>
        我是泰国人 = ฉันเป็นคนไทย<br>
        谢谢。 = ขอบคุณ</div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BForm, BCard, BCardHeader, BCardBody, BFormGroup, BButton, BImg, BLink,
} from 'bootstrap-vue'

export default {
  components: {
    BForm, BCard, BCardHeader, BCardBody, BFormGroup, BButton, BImg, BLink,
  },
};
</script>
<style scoped>
a:hover {
  background-color: #0079b3;
  color: white;
}
</style>